import { inject } from '@angular/core';
import { EmployeePositionApiService } from '@shared/services';
import { TableConfig } from '../generic-p-table.interfaces';

export const empPosDeptHistoryTableConfig = (): TableConfig => {
  const employeePositionApiService = inject(EmployeePositionApiService);

  return {
    useApiData: true,
    service: employeePositionApiService,
    method: 'getEmpPosDeptHistory',
    title: 'Lịch sử chuyển team',
    entityName: 'lịch sử chuyển team',
    columns: [
      { field: 'department.name', header: 'Phòng ban', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'fromDate', header: 'Ngày bắt đầu', width: 'min-w-[100px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' }
    ],
    features: {
      virtualScroll: true,
      toolbar: false,
      pagination: true
    },
    itemsPerPage: 10,
    itemsPerPageOptions: [5, 10, 20],
    // Use path parameter support for GET requests
    usePathParameter: true,
    pathParameterExtractor: (employeePositionId: any) => {
      return employeePositionId;
    }
  };
};
